import ErrorFallback from 'Components/ErrorFallback/ErrorFallback'
import type { NavLinkItem } from 'Components/Layout/DrawerMenu/types'
import { DrawerLayout } from 'Components/Layout/Templates/DrawerLayout/DrawerLayout'
import SchoolRoot from 'Services/SchoolManagement/Features/School'
import SchoolCalendarRoot from 'Services/SchoolManagement/Features/SchoolCalendar'
import { SCHOOL_MANAGEMENT_ROOT_URL } from 'Util/constants'
import EventIcon from '@mui/icons-material/Event'
import SchoolIcon from '@mui/icons-material/School'
import { ErrorBoundary } from 'react-error-boundary'
import { Navigate, Route, Routes } from 'react-router-dom'
import { t } from 'ttag'

const getMenuBarNavLinks = (): NavLinkItem[] => [
  {
    title: t`Schools`,
    link: `${SCHOOL_MANAGEMENT_ROOT_URL}/schools`,
    icon: <SchoolIcon fontSize="small" />
  },
  {
    title: t`Calendars`,
    link: `${SCHOOL_MANAGEMENT_ROOT_URL}/school-calendars`,
    icon: <EventIcon fontSize="small" />
  }
]

function SchoolManagement() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route
          element={
            <DrawerLayout rootUrl="/school-management/" drawerMenuNavLinks={getMenuBarNavLinks()} />
          }
          path="/"
        >
          <Route index element={<Navigate to="schools/" />} />
          <Route path="/schools/*" element={<SchoolRoot />} />
          <Route path="/school-calendars/*" element={<SchoolCalendarRoot />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  )
}

export default SchoolManagement
